import { Button, Stack, Tooltip, Typography } from '@mui/material';
import { useNavigate } from 'react-router';

import { url } from '../../appRouter/url.ts';
import { PaperWithShadow } from '../../components/general/PaperWithShadow.tsx';
import { StickyWrapperWithBlur } from '../../components/general/StickyWrapper.tsx';
import { content } from './CreateDurchgang.content.ts';

type DurchgangPlanungHeaderProps = {
  readonly akaProduktId: string;
  readonly handleSave: () => Promise<void>;
  readonly disableSaveButton: boolean;
  readonly saveButtonTooltip: string;
};

export const DurchgangPlanungHeader = ({
  akaProduktId,
  handleSave,
  disableSaveButton,
  saveButtonTooltip,
}: DurchgangPlanungHeaderProps) => {
  const navigate = useNavigate();

  const handleCancel = async (): Promise<void> => {
    await navigate(url.thema.details(akaProduktId));
  };

  return (
    <StickyWrapperWithBlur sx={{ mt: -2, width: '100%' }}>
      <PaperWithShadow>
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ height: '34px' }}>
          <Typography variant="headingXs">Durchgang anlegen</Typography>

          <Stack direction="row" spacing={2}>
            <Button size="small" onClick={() => void handleCancel()} variant="outlined" sx={{ height: '34px' }}>
              {content.buttons.cancel}
            </Button>
            <Tooltip arrow placement="top" title={saveButtonTooltip} data-testid="actionButtonsTooltip">
              <div>
                <Button size="small" variant="contained" disabled={disableSaveButton} onClick={() => void handleSave()}>
                  {content.buttons.save}
                </Button>
              </div>
            </Tooltip>
          </Stack>
        </Stack>
      </PaperWithShadow>
    </StickyWrapperWithBlur>
  );
};
